import { render, staticRenderFns } from "./SkillEditModal.vue?vue&type=template&id=22210d8e&scoped=true"
import script from "./SkillEditModal.vue?vue&type=script&lang=js"
export * from "./SkillEditModal.vue?vue&type=script&lang=js"
import style0 from "./SkillEditModal.vue?vue&type=style&index=0&id=22210d8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22210d8e",
  null
  
)

export default component.exports